const PolicyTerm = () => {
    return (
        <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
            <h1 style={{ textAlign: "center" }}>Polityka Prywatności – Checkardi</h1>

            <p>
                Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych
                Użytkowników serwisu internetowego Checkardi oraz korzystania z plików cookies.
                Serwis jest powiązany z aplikacją mobilną Checkardi.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 1 Administrator danych</h2>
            <p>Administratorem danych osobowych jest:</p>
            <p><strong>Natalia Jagiełło</strong></p>
            <p>
                Adres e-mail:{" "}
                <a href="mailto:jagiello.nat@gmail.com">jagiello.nat@gmail.com</a>
            </p>
            <p>
                Administrator przetwarza dane zgodnie z RODO oraz innymi obowiązującymi
                przepisami prawa.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 2 Zakres przetwarzanych danych</h2>
            <ul>
                <li>imię lub nazwa użytkownika</li>
                <li>adres e-mail</li>
                <li>dane konta Google (Google Sign-In)</li>
                <li>treść opinii i recenzji</li>
                <li>zdjęcia dodawane przez użytkownika</li>
                <li>dane techniczne (np. adres IP)</li>
            </ul>

            <h2 style={{ textAlign: "center" }}>§ 3 Logowanie przez Google</h2>
            <p>
                Serwis umożliwia logowanie i rejestrację za pomocą usługi Google Sign-In.
                W ramach tego procesu Administrator otrzymuje od Google podstawowe dane
                identyfikacyjne, takie jak adres e-mail i nazwa profilu.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 4 Weryfikacja zdjęć</h2>
            <p>
                Zdjęcia dodawane przez użytkowników mogą podlegać weryfikacji manualnej lub
                automatycznej w celu zapewnienia bezpieczeństwa, zgodności z regulaminem
                oraz zapobiegania nadużyciom.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 5 Cele przetwarzania danych</h2>
            <ul>
                <li>świadczenie usług serwisu</li>
                <li>obsługa kont użytkowników</li>
                <li>moderacja treści</li>
                <li>zapewnienie bezpieczeństwa</li>
                <li>realizacja obowiązków prawnych</li>
            </ul>

            <h2 style={{ textAlign: "center" }}>§ 6 Odbiorcy danych</h2>
            <ul>
                <li>dostawcy usług hostingowych (np. Microsoft Azure)</li>
                <li>dostawcy infrastruktury IT</li>
                <li>Google LLC – w zakresie logowania</li>
            </ul>
            <p>Dane nie są sprzedawane ani wykorzystywane do celów reklamowych.</p>

            <h2 style={{ textAlign: "center" }}>§ 7 Okres przechowywania danych</h2>
            <p>
                Dane użytkownika są przechowywane do momentu usunięcia konta przez
                użytkownika lub Administratora.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 8 Prawa użytkownika</h2>
            <ul>
                <li>dostępu do danych</li>
                <li>sprostowania danych</li>
                <li>usunięcia danych</li>
                <li>ograniczenia przetwarzania</li>
                <li>wniesienia skargi do Prezesa UODO</li>
            </ul>

            <h2 style={{ textAlign: "center" }}>§ 9 Cookies</h2>
            <p>
                Serwis wykorzystuje pliki cookies w celu prawidłowego działania oraz
                utrzymania sesji logowania.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 10 Bezpieczeństwo</h2>
            <p>
                Administrator stosuje środki techniczne i organizacyjne, w tym szyfrowanie
                HTTPS oraz zabezpieczenia baz danych.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 11 Zmiany polityki</h2>
            <p>
                Administrator zastrzega sobie prawo do zmiany niniejszej Polityki
                Prywatności. Aktualna wersja jest zawsze dostępna w serwisie.
            </p>
        </div>
    );
};

export default PolicyTerm;
